import React, { Suspense } from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AnimatedPageLoader } from 'smartsuite-ui';
import { ToastContainer } from 'react-toastify';
import { toastContainerProps } from './constants/toastConstants';
import ErrorBoundary from './components/ErrorBoundary';

import 'react-toastify/dist/ReactToastify.css';
import 'smartsuite-ui/dist/smartsuite-ui.css';
import './less/brands.css';
import './i18n';

const ConfigurationAppWrapper = React.lazy(() =>
    import('./apps/Configuration/ConfigurationAppWrapper')
);
const PrinterDashboardAppWrapper = React.lazy(() =>
    import('./apps/PrinterDashboard/App')
);
const DefaultRoute = React.lazy(() => import('./components/DefaultRoute'));
const WelcomePage = React.lazy(() => import('./components/WelcomePage'));

const rootElement = document.getElementById('root');

const queryClient = new QueryClient({
    defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

render(
    <ErrorBoundary>
        <Suspense fallback={<AnimatedPageLoader />}>
            <Router basename={window.rootUrl}>
                <Switch>
                    <QueryClientProvider client={queryClient}>
                        <Route
                            path="/apps/Configuration"
                            component={ConfigurationAppWrapper}
                        />
                        <Route
                            path="/apps/printerDashboard"
                            component={PrinterDashboardAppWrapper}
                        />
                        <Route path="/apps/welcome" component={WelcomePage} />
                        <Route exact={true} path="/" component={DefaultRoute} />
                        <ReactQueryDevtools initialIsOpen={false} />
                    </QueryClientProvider>
                </Switch>
            </Router>
            <ToastContainer {...toastContainerProps} />
        </Suspense>
    </ErrorBoundary>,
    rootElement
);
